<div class="container-overview-wrapper">
    <app-area-header
        [largeHeadline]="largeHeadline"
        [smallHeadlineTranslationKey]="smallHeadlineTranslationKey"
        [profilePicture]="headerPicture"
        [round]="false"
        [buttonTextTranslationKey]="createButtonTranslationKey"
        (buttonClicked)="onOpenCreationWizard()"
    ></app-area-header>
    <div class="container-overview-search-options">
        <app-container-search-field
            [placeholderTranslationKey]="
            'navigation.menu.components.menu.workspace.inputPlaceholder'
        "
            [initialSearchText]="searchTerm"
            [width]="'fixed'"
            [initialSortOption]="'new-old'"
            [resetTrigger$]="resetSearchTrigger$"
            [type]="type"
            (searchChanged)="onSearchChange($event)"
        ></app-container-search-field>
    </div>
    <div
        *ngIf="searchTerm && searchTerm.length > 0"
        class="d-flex flex-row justify-content-start search-results-container"
    >
    <span class="search-results-text"
    >{{
            'workspace.components.containerOverview.searchResultsPrefix'
                | translate
        }}
        <span class="search-term">{{ searchTerm }}</span>
        {{
            'workspace.components.containerOverview.searchResultsSuffix'
                | translate
        }}</span
    >
        <span
            class="reset-search-button"
            (click)="onSearchCleared()"
            (keyup.enter)="onSearchCleared()"
        >{{
                'workspace.components.containerOverview.resetSearch' | translate
            }}</span
        >
    </div>
    <div *ngIf="type" class="container-fluid container-library-component-wrapper">
        <app-container-library></app-container-library>
    </div>
</div>
